import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setActiveTab } from "store/Actions/ProjectModule/projectActionCreators";
import Select from "react-select";

// component
import ButtonElement from "Components/UI/Button";

// Images
import images from "Assets/images";

// helper
import tabs, { GLOBAL_VARIABLES_TAB_ID, languageOptions } from "StaticData/Dashboard/tabs";
import { usePermissions } from "Hooks/usePermissions";

// css
import "./style.css";
import "Assets/css/style.css";
import "Assets/css/common.css";
import "Assets/css/booking-list.css";
import "Assets/css/booking-form.css";
import "Assets/css/site-management.css";
import "Assets/css/global-admin.css";
import "Assets/css/cutstmize.css";
import ProjectCreateModal from "../Modal/ProjectCreateModal";

const index = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isGlobalAdmin, isAdmin, isVoyageControlGlobalAdmin } = usePermissions();

  const options = languageOptions;

  const [collapseTab, setCollapseTab] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [activeParentId, setActiveParentId] = useState<number | null>(null);
  
  

const ADMIN_ALLOWED_TAB_IDS = [1, 2, 4]; 


const filteredTabs = isGlobalAdmin
  ? tabs.filter((tab) => tab.id !== GLOBAL_VARIABLES_TAB_ID || isVoyageControlGlobalAdmin)
  : isAdmin
  ? tabs.filter((tab) => ADMIN_ALLOWED_TAB_IDS.includes(tab.id))
  : [];

  const handleClick = () => {
    setCollapseTab(!collapseTab);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenCreateProjectModel = () => {
    setIsModalOpen(true);
  };

  const handleClickTab = (
    tabUrl: string,
    hasSubTabs = false,
    parentId?: number
  ) => {
    
    dispatch(setActiveTab(tabUrl));

    if (hasSubTabs && parentId !== undefined) {
      setActiveParentId((prevId) => (prevId === parentId ? null : parentId));
    }
  };

  return (
    <>
      <ProjectCreateModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
      <ul
        className={
          collapseTab
            ? "navbar-nav sidebar accordion toggled"
            : "navbar-nav sidebar accordion"
        }
        id="accordionSidebar"
      >
        {collapseTab ? (
          <ButtonElement
            className="btn theme-btn add-booking plusicon_button toggled"
            buttonLabel={
              <span>
                <img src={images.plusIcon} alt="plus" />
              </span>
            }
            handleClick={() => handleOpenCreateProjectModel()}
          />
        ) : (
          <ButtonElement
            className="btn theme-btn add-booking"
            buttonLabel={
              <span>
                <img src={images.plusIcon} alt="plus" />{" "}
                {t("Translation.new_project")}
              </span>
            }
            handleClick={() => handleOpenCreateProjectModel()}
          />
        )}
        
        {(isGlobalAdmin || isAdmin) ? (
          <>
            {filteredTabs.map(({ Icon, subTabs, ...item }) => {
              const isActive = location.pathname.includes(item.url);
              const isExpanded = activeParentId === item.id;

              return (
                <React.Fragment key={item.id}>
                  <li
                    onClick={() => handleClickTab(item.url, !!subTabs, item.id)}
                    className={`nav-item ${isActive || isExpanded ? "active" : ""}`}
                  >
                    <Link to={item.url} className="nav-link">
                      <Icon width={16} height={16} />
                      <span style={{ marginLeft: 10 }}>
                        {t(`Translation.${item.name}`)}
                      </span>
                    </Link>
                  </li>

                  {subTabs &&
                    isExpanded &&
                    subTabs.map((subTab) => (
                      <li
                        key={subTab.id}
                        onClick={() => handleClickTab(subTab.url)}
                        className={`nav-item sub-tab ${
                          location.pathname.includes(subTab.url) ? "active" : ""
                        }`}
                      >
                        <Link to={subTab.url} className="nav-link">
                          <span style={{ marginLeft: 32 }}>
                            {t(`Translation.${subTab.name}`)}
                          </span>
                        </Link>
                      </li>
                    ))}
                </React.Fragment>
              );
            })}
          </>
        ) : (
          <>
            {tabs
              .filter((tab) => ADMIN_ALLOWED_TAB_IDS.includes(tab.id))
              .map(({ Icon, subTabs, ...item }) => {
                const isActive = location.pathname.includes(item.url);
                const isExpanded = activeParentId === item.id;

                return (
                  <React.Fragment key={item.id}>
                    <li
                      onClick={() =>
                        handleClickTab(item.url, !!subTabs, item.id)
                      }
                      className={`nav-item ${isActive || isExpanded ? "active" : ""}`}
                    >
                      <Link to={item.url} className="nav-link">
                        <Icon width={16} height={16} />
                        <span style={{ marginLeft: 10 }}>
                          {t(`Translation.${item.name}`)}
                        </span>
                      </Link>
                    </li>
                  </React.Fragment>
                );
              })}
          </>
        )}


        <li className="nav-item bottom-links">
          <div
            className={
              collapseTab
                ? "form-group mb-0 toggled"
                : "form-group mb-0 toggled"
            }
          >
            <Select
              classNamePrefix="form-control-language"
              options={options}
              value={options.find((c) => c.value === selectedOption)}
              onChange={(val: any) => setSelectedOption(val)}
            />
          </div>
        </li>
        <li key="8" className="nav-item">
          <Link
            to="#"
            onClick={() => handleClick()}
            className="nav-link collapse"
          >
            <img alt="collapse" src={images.collapse} />
            <span>{t("Translation.collapse")}</span>
          </Link>
        </li>
      </ul>
    </>
  );
};

export default index;
